export default __webpack_public_path__ + "static/media/faq-hero.f1587ca5.png";